"use client";

import { MenubarScopedContextProvider, useMenubarProviderContext } from "./62UHHO2X.js";
import { useMenubarStore } from "./BKQBQI36.js";
import { useComposite } from "./ITI7HKP4.js";
import { createElement, createHook, forwardRef } from "./LMDWO4NN.js";
import { useWrapElement } from "./ABQUS43J.js";
import { __objRest, __spreadValues } from "./3YLGPPWQ.js";

// src/menubar/menubar.tsx
import { jsx } from "react/jsx-runtime";
var TagName = "div";
var useMenubar = createHook(function useMenubar2(_a) {
  var _b = _a,
    storeProp = _b.store,
    _b$composite = _b.composite,
    composite = _b$composite === void 0 ? true : _b$composite,
    orientationProp = _b.orientation,
    virtualFocus = _b.virtualFocus,
    focusLoop = _b.focusLoop,
    rtl = _b.rtl,
    props = __objRest(_b, ["store", "composite", "orientation", "virtualFocus", "focusLoop", "rtl"]);
  var context = useMenubarProviderContext();
  storeProp = storeProp || context;
  var store = useMenubarStore({
    store: storeProp,
    orientation: orientationProp,
    virtualFocus: virtualFocus,
    focusLoop: focusLoop,
    rtl: rtl
  });
  var orientation = store.useState(function (state) {
    return !composite || state.orientation === "both" ? void 0 : state.orientation;
  });
  props = useWrapElement(props, function (element) {
    return /* @__PURE__ */jsx(MenubarScopedContextProvider, {
      value: store,
      children: element
    });
  }, [store]);
  if (composite) {
    props = __spreadValues({
      role: "menubar",
      "aria-orientation": orientation
    }, props);
  }
  props = useComposite(__spreadValues({
    store: store,
    composite: composite
  }, props));
  return props;
});
var Menubar = forwardRef(function Menubar2(props) {
  var htmlProps = useMenubar(props);
  return createElement(TagName, htmlProps);
});
export { useMenubar, Menubar };